import styles from "./styles.module.scss";
import { useQuery } from "@tanstack/react-query";
import { useAtomValue } from "jotai";
import { userData } from "../../../state";
import {
  EventType,
  MemberType,
  getRegisteredCorporateEvents,
} from "../../../requests";
import Button from "../../../custom/button/button";
import { getDateWithoutTime } from "../../../utils/formatDate";
import { useNavigate } from "react-router-dom";
import { Spin } from "antd";
import { AxiosError } from "axios";

interface Props {
  eventType: EventType;
}

const RegisteredCorporateEvents = ({ eventType }: Props) => {
  const user = useAtomValue(userData);
  const navigate = useNavigate();
  const isCorporate = user?.MembershipTypeId === MemberType.Corporate;
  const currentEvent =
    eventType === "Training"
      ? "trainings"
      : eventType === "Conference"
      ? "conferences"
      : "others";

  const corporateEvents = useQuery({
    queryKey: ["get-registered-corporate-events", user?.MemberId!],
    queryFn: () => getRegisteredCorporateEvents(user?.MemberId!, eventType),
    enabled: isCorporate && !!user?.MemberId,
  });

  if (corporateEvents.isLoading)
    return <Spin style={{ justifySelf: "center", alignSelf: "center" }} />;
  if (corporateEvents.isError)
    return <div>{(corporateEvents.error as AxiosError)?.message}</div>;

  return (
    <div>
      {corporateEvents?.data && corporateEvents?.data?.Data?.length > 0 && (
        <h3>Registered {eventType === "Other" ? "Events" : `${eventType}s`}</h3>
      )}
      {corporateEvents?.data && corporateEvents?.data?.Data?.length > 0
        ? corporateEvents?.data?.Data?.map((item) => {
            const dateWithoutTime = getDateWithoutTime(item?.StartDate);
            return (
              <section className={styles.events} key={item.Id}>
                <div className={styles.event}>
                  <div className={styles.center}>
                    <label className={styles.month}>
                      {dateWithoutTime?.split(" ")?.slice(1)?.join(" ")}
                    </label>
                    <h4 className={styles.date}>
                      {dateWithoutTime?.split(" ")?.slice(0, 1)?.join(" ")}
                    </h4>
                  </div>
                  <hr />
                  <section className={styles.spaceBetween}>
                    <div className={styles.eventDetails}>
                      <h4>{item.EventName}</h4>
                    </div>
                    <Button
                      className={styles.greyBtn}
                      onClick={() =>
                        navigate(
                          `/event-application/registered-${currentEvent}/${item.Id}/${item.EventId}`
                        )
                      }
                      text="View"
                    />
                  </section>
                </div>
              </section>
            );
          })
        : null}
    </div>
  );
};

export default RegisteredCorporateEvents;
